/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoTransworldIndicator implements angular.IDirective {
        dataService: Meevo.Components.BaseClasses.IDataService;
        appSettings: Meevo.Components.Common.IAppSettings;
        $q: ng.IQService;
        $rootScope: ng.IRootScopeService;
        restrict = 'E';
        scope = {
            clientId: '=',
            clientMembershipId: '=',
            isHeader: '=?',
            isSentToTransworld: '=?',
            peekAlert: "=?",
            hasAlert: "&?"
        };

        templateUrl = 'app/components/controls/clientTransworldIndicatorTemplate.html';

        link = (scope: any) => {
            let clientIdList = [];
            let params = {};
            let requestUrl = {
                transworldSettings: `/${Meevo.AppSettings.Default.API_ROOT}/settings/transworldFields/`,
                clientList: `/${Meevo.AppSettings.Default.API_ROOT}/Transworld/Client/List`
            };

            var vm = this;
            scope.sendToMembership = function() {
                if (!scope.clientMembershipId) return;

                vm.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: vm.appSettings.ROUTE_NAMES.membershipManager,
                    stateParams: {
                        actionState: Meevo.Model.MaintenanceFormState.Readonly,
                        targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                        id: scope.clientMembershipId,
                        initialEditSection: 'SECTION_MEMBERSHIPMANAGER_PAYMENTS'
                    },
                });

                vm.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_SEARCH_MENU);
            }

            scope.$watch('clientId', clientId => {
                if (scope.isGetInfo) {
                    scope.isSentToTransworld = undefined;
                }

                if (clientId && angular.isUndefined(scope.isSentToTransworld)) {
                    this.dataService.customMethodData(requestUrl.transworldSettings, 'GET', null)
                        .then(response => {
                            if (!response.data.enableTransworld) return this.$q.reject();

                            return this.dataService.customMethodData(requestUrl.clientList, 'POST', { clients: [scope.clientId] });
                        }).then(response => {
                            if (response.data[0].isSentToTransworld) {
                                scope.isSentToTransworld = response.data[0].isSentToTransworld;
                                if (scope.hasAlert && scope.isSentToTransworld) {
                                    scope.hasAlert();
                                }
                                scope.isGetInfo = true;
                            }
                        });
                }
            });
        }

        constructor(
            $rootScope: ng.IRootScopeService,
            appSettings: Meevo.Components.Common.IAppSettings,
            $q: ng.IQService,
            dataService: Meevo.Components.BaseClasses.IDataService
        ) {
            this.dataService = dataService;
            this.$rootScope = $rootScope;
            this.appSettings = appSettings;
            this.$q = $q;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: ng.IRootScopeService,
                appSettings: Meevo.Components.Common.IAppSettings,
                $q: ng.IQService,
                dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoTransworldIndicator($rootScope, appSettings, $q, dataService);
            }

            directive.$inject = ['$rootScope', 'meevo.AppSettings', '$q', 'meevo.components.common.DataService'];
            return directive;
        }
    }

    angular.module('meevo.components.controls').directive('meevoTransworldIndicator', MeevoTransworldIndicator.factory());
}